import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  hash3na0rjynj3lfb as hash,
  hash261sfwzhzsh4z as hash_0,
} from '../../../../../../../../crowpay-shared/com/crowpay/extensions/PendingLineItem.ext.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  singleOrNull21olsob387p54 as singleOrNull,
  first58ocm7j58k3q as first,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IdAndFeedback5bkoyzmnn7cz as IdAndFeedback,
  HashAndManyFeedback2qtcgu6w92gzs as HashAndManyFeedback,
  LineItemFromChangeRequest29s1k7nucgyuu as LineItemFromChangeRequest,
  HashAndFeedback2e8ptt71irxk8 as HashAndFeedback,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { ChangeRequestItemWrapperlr7b47p0t9ty as ChangeRequestItemWrapper } from './data.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  to2cs3ny02qtbcb as to,
  Paire9pteg33gng7 as Pair,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  ItemChangee3c665suy3yz as ItemChange,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  Projecto73xqbcrzskm as Project,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { hash2c804431zmucg as hash_1 } from '../../../../../../../../crowpay-shared/com/crowpay/extensions/PendingItemChange.ext.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Action1a4ymn5nx79hk as Action } from '../../../../../utils/utils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../nav/crowpay.mjs';
import {
  PayForChange3tpjo85o3asyb as PayForChange,
  MakePaymentInfoBandaidDialog18vq2rlet73fk as MakePaymentInfoBandaidDialog,
} from '../../../../dialogs/MakePaymentDialog.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../../dialogs/GenericConfirmationDialog.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DenyChangeItemsDialog2gm5ndqwtjj7b as DenyChangeItemsDialog } from '../../../../dialogs/PagedUserTextInputDialog.mjs';
import { DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance } from '../../../../theming/buttons.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_reviewSelected__39ic6j(itemsAndFeedback, approved, $completion) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(itemsAndFeedback, 10));
  var _iterator__ex2g4s = itemsAndFeedback.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.af_1;
    destination.v(tmp$ret$0);
  }
  var items = destination;
  if (items.i1())
    throw IllegalArgumentException().a1('Must provide pending line items to approve');
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = items.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    if (element.s94()) {
      destination_0.v(element);
    }
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = destination_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_0 = _iterator__ex2g4s_1.o1();
    var tmp0_safe_receiver = get_pendingLineItem(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.v(tmp0_safe_receiver);
    }
  }
  var linkedItems = destination_1;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!linkedItems.i1()) {
    var hash_2 = hash(linkedItems);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList().u(collectionSizeOrDefault(linkedItems, 10));
    var _iterator__ex2g4s_2 = linkedItems.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var item_0 = _iterator__ex2g4s_2.o1();
      var tmp$ret$15 = item_0.x75_1;
      destination_2.v(tmp$ret$15);
    }
    var tmp0_elvis_lhs = singleOrNull(toSet(destination_2));
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList().u(collectionSizeOrDefault(items, 10));
      var _iterator__ex2g4s_3 = items.m1();
      while (_iterator__ex2g4s_3.n1()) {
        var item_1 = _iterator__ex2g4s_3.o1();
        var tmp$ret$18 = item_1.q94();
        destination_3.v(tmp$ret$18);
      }
      throw IllegalArgumentException().a1('All line items must be from the same change request. Found IDs: ' + toString(destination_3));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var linkedChangeRequest = tmp_0;
    // Inline function 'kotlin.run' call
    var $this$run = session.tfw().jff_1;
    if (approved) {
      var tmp_1 = $this$run.qfh(linkedChangeRequest, hash_2, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_4 = ArrayList().w();
      var _iterator__ex2g4s_4 = itemsAndFeedback.m1();
      while (_iterator__ex2g4s_4.n1()) {
        var element_1 = _iterator__ex2g4s_4.o1();
        if (element_1.af_1.s94()) {
          destination_4.v(element_1);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_5 = ArrayList().u(collectionSizeOrDefault(destination_4, 10));
      var _iterator__ex2g4s_5 = destination_4.m1();
      while (_iterator__ex2g4s_5.n1()) {
        var item_2 = _iterator__ex2g4s_5.o1();
        var tmp$ret$24 = new (IdAndFeedback())(item_2.af_1.h40(), item_2.bf_1);
        destination_5.v(tmp$ret$24);
      }
      var tmp_2 = $this$run.rfh(linkedChangeRequest, new (HashAndManyFeedback())(hash_2, destination_5), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_6 = ArrayList().w();
  var _iterator__ex2g4s_6 = items.m1();
  while (_iterator__ex2g4s_6.n1()) {
    var element_2 = _iterator__ex2g4s_6.o1();
    if (!element_2.s94()) {
      destination_6.v(element_2);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_7 = ArrayList().u(collectionSizeOrDefault(destination_6, 10));
  var _iterator__ex2g4s_7 = destination_6.m1();
  while (_iterator__ex2g4s_7.n1()) {
    var item_3 = _iterator__ex2g4s_7.o1();
    var tmp_3;
    if (item_3 instanceof ChangeRequestItemWrapper()) {
      tmp_3 = item_3.mgp_1;
    } else {
      tmp_3 = item_3;
    }
    var tmp$ret$32 = tmp_3;
    destination_7.v(tmp$ret$32);
  }
  var nonLinkedItems = destination_7;
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(itemsAndFeedback, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_8 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_8 = itemsAndFeedback.m1();
  while (_iterator__ex2g4s_8.n1()) {
    var element_3 = _iterator__ex2g4s_8.o1();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element_3.af_1.h40(), element_3.bf_1);
    destination_8.s3(pair.af_1, pair.bf_1);
  }
  var feedback = destination_8;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_9 = nonLinkedItems.m1();
  while (_iterator__ex2g4s_9.n1()) {
    var element_4 = _iterator__ex2g4s_9.o1();
    if (element_4 instanceof PendingLineItem()) {
      // Inline function 'kotlin.run' call
      var $this$run_0 = session.tfw().ofg_1;
      if (approved) {
        var tmp_4 = $this$run_0.ofo(element_4.v75_1, hash_0(element_4), $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
      } else {
        var tmp_5 = hash_0(element_4);
        var tmp0_elvis_lhs_0 = feedback.p3(element_4.v75_1);
        var tmp_6;
        if (tmp0_elvis_lhs_0 == null) {
          throw IllegalArgumentException().a1('No feedback for ' + element_4.toString());
        } else {
          tmp_6 = tmp0_elvis_lhs_0;
        }
        var tmp_7 = $this$run_0.pfo(element_4.v75_1, new (HashAndFeedback())(tmp_5, tmp_6), $completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
      }
    } else {
      if (element_4 instanceof PendingItemChange()) {
        // Inline function 'kotlin.run' call
        var $this$run_1 = session.tfw().nfg_1;
        if (approved) {
          var tmp_8 = $this$run_1.gfo(element_4.c72_1, hash_1(element_4), $completion);
          if (tmp_8 === get_COROUTINE_SUSPENDED())
            tmp_8 = yield tmp_8;
        } else {
          var tmp_9 = hash_1(element_4);
          var tmp0_elvis_lhs_1 = feedback.p3(element_4.c72_1);
          var tmp_10;
          if (tmp0_elvis_lhs_1 == null) {
            throw IllegalArgumentException().a1('No feedback for ' + element_4.toString());
          } else {
            tmp_10 = tmp0_elvis_lhs_1;
          }
          var tmp_11 = $this$run_1.hfo(element_4.c72_1, new (HashAndFeedback())(tmp_9, tmp_10), $completion);
          if (tmp_11 === get_COROUTINE_SUSPENDED())
            tmp_11 = yield tmp_11;
        }
      } else {
        var tmp_12;
        if (element_4 instanceof LineItemFromChangeRequest()) {
          tmp_12 = true;
        } else {
          tmp_12 = element_4 instanceof ItemChange();
        }
        if (tmp_12) {
          println('WARN: Attempted to approve already approved item');
          return Unit_instance;
        } else {
          throw IllegalArgumentException().a1('Unsupported ChangeRequestItem type');
        }
      }
    }
  }
  return Unit_instance;
}
function reviewSelected(itemsAndFeedback, approved, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_reviewSelected__39ic6j.bind(VOID, itemsAndFeedback, approved), $completion);
}
function approveSelectedItems(items, $completion) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(items, 10));
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = new (Pair())(item, '');
    destination.v(tmp$ret$0);
  }
  return reviewSelected(destination, true, $completion);
}
function denySelectedItems(itemsAndFeedback, $completion) {
  return reviewSelected(itemsAndFeedback, false, $completion);
}
function get_pendingLineItem(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
    tmp = get_pendingLineItem(_this__u8e3s4.mgp_1);
  } else {
    if (_this__u8e3s4 instanceof PendingLineItem()) {
      tmp = _this__u8e3s4;
    } else {
      if (_this__u8e3s4 instanceof PendingItemChange()) {
        tmp = null;
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestItem type');
      }
    }
  }
  return tmp;
}
function get_project(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
    tmp = get_project(_this__u8e3s4.mgp_1);
  } else {
    if (_this__u8e3s4 instanceof PendingLineItem()) {
      tmp = _this__u8e3s4.w75_1;
    } else {
      if (_this__u8e3s4 instanceof PendingItemChange()) {
        tmp = _this__u8e3s4.d72_1;
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestItem type');
      }
    }
  }
  return tmp;
}
function approveSelected(_this__u8e3s4, changeItems) {
  return Action('Approve Selected Items', VOID, approveSelected$slambda_0(changeItems));
}
function denySelected(_this__u8e3s4, changeItems) {
  return Action('Deny Selected Items', VOID, denySelected$slambda_0(changeItems));
}
function *_generator_voidChangeItem__vu4hm7(item, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp0_safe_receiver = item instanceof ChangeRequestItemWrapper() ? item : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mgp_1;
  var item_0 = tmp1_elvis_lhs == null ? item : tmp1_elvis_lhs;
  if (item_0 instanceof PendingLineItem()) {
    var tmp_0 = session.tfw().ofg_1.qfo(item_0.v75_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    session.sfv_1.bft(tmp_0);
  } else {
    if (item_0 instanceof PendingItemChange()) {
      var tmp_1 = session.tfw().nfg_1.ifo(item_0.c72_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      session.tfv_1.bft(tmp_1);
    } else {
      throw IllegalArgumentException().a1('Only pending change items can be voided');
    }
  }
  return Unit_instance;
}
function voidChangeItem(item, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_voidChangeItem__vu4hm7.bind(VOID, item), $completion);
}
function voidItemAction(_this__u8e3s4, changeItem) {
  return Action('Void Change Item', VOID, voidItemAction$slambda_0(changeItem));
}
function *_generator_invoke__zhh2q8($this, confirmed, $completion) {
  if (!confirmed)
    return Unit_instance;
  var tmp = approveSelectedItems($this.kh7_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (MonetaryValue__compareTo_impl_w7ul1r($this.lh7_1, Companion_instance.p91(0n)) > 0) {
    get_dialogStack().ebw(new (MakePaymentInfoBandaidDialog())($this.mh7_1, new (PayForChange())($this.lh7_1)));
  } else {
    get_dialogStack().ngd();
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$Action, $completion) {
  var tmp = $this.nh7_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var items = tmp;
  if (items.i1())
    throw IllegalArgumentException().a1('Cannot approve an empty list');
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp_0.pfv_1.kft(get_project(first(items)));
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_elvis_lhs = tmp_1;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Project()), null);
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  var project = tmp_2;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_3 = sum;
    var tmp0_elvis_lhs_0 = element.u94();
    var tmp_4;
    var tmp_5 = tmp0_elvis_lhs_0;
    if ((tmp_5 == null ? null : new (MonetaryValue())(tmp_5)) == null) {
      tmp_4 = Companion_instance.p91(0n);
    } else {
      tmp_4 = tmp0_elvis_lhs_0;
    }
    var tmp$ret$2 = tmp_4;
    sum = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$2);
  }
  var priceChange = sum;
  var fundsNeeded = MonetaryValue__minus_impl_jw9qyp(priceChange, project.t97());
  var tmp_6 = get_dialogStack();
  var tmp_7 = 'Approve ' + items.p1() + ' Item(s)?';
  var tmp_8 = MonetaryValue__compareTo_impl_w7ul1r(fundsNeeded, Companion_instance.o62(0)) > 0 && project.t97() === Companion_instance.o62(0) ? 'You will need to add ' + MonetaryValue__toString_impl_xslc77(fundsNeeded) + ' to the escrow.' : MonetaryValue__compareTo_impl_w7ul1r(fundsNeeded, Companion_instance.p91(0n)) > 0 ? 'This will increase the price of the project by ' + MonetaryValue__toString_impl_xslc77(priceChange) + ', you will need to add ' + MonetaryValue__toString_impl_xslc77(fundsNeeded) + ' to the escrow and the remaining funds will be taken from surplus.' : MonetaryValue__compareTo_impl_w7ul1r(priceChange, Companion_instance.p91(0n)) > 0 ? 'This will increase the price of the project by ' + MonetaryValue__toString_impl_xslc77(priceChange) + ', the funds will be taken from the escrow surplus.' : 'This action cannot be undone.';
  tmp_6.xgd(new (GenericConfirmationDialog())(tmp_7, tmp_8, VOID, 'Approve Selected', VOID, VOID, VOID, false, VOID, VOID, approveSelected$slambda$slambda_0(items, fundsNeeded, project)));
  return Unit_instance;
}
var approveSelected$slambda$slambdaClass;
function approveSelected$slambda$slambda() {
  if (approveSelected$slambda$slambdaClass === VOID) {
    class $ {
      constructor($items, $fundsNeeded, $project) {
        this.kh7_1 = $items;
        this.lh7_1 = $fundsNeeded;
        this.mh7_1 = $project;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    approveSelected$slambda$slambdaClass = $;
  }
  return approveSelected$slambda$slambdaClass;
}
function approveSelected$slambda$slambda_0($items, $fundsNeeded, $project) {
  var i = new (approveSelected$slambda$slambda())($items, $fundsNeeded, $project);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var approveSelected$slambdaClass;
function approveSelected$slambda() {
  if (approveSelected$slambdaClass === VOID) {
    class $ {
      constructor($changeItems) {
        this.nh7_1 = $changeItems;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    approveSelected$slambdaClass = $;
  }
  return approveSelected$slambdaClass;
}
function approveSelected$slambda_0($changeItems) {
  var i = new (approveSelected$slambda())($changeItems);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$Action, $completion) {
  var tmp = $this.oh7_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var items = tmp;
  get_dialogStack().xgd(DenyChangeItemsDialog(items));
  return Unit_instance;
}
var denySelected$slambdaClass;
function denySelected$slambda() {
  if (denySelected$slambdaClass === VOID) {
    class $ {
      constructor($changeItems) {
        this.oh7_1 = $changeItems;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    denySelected$slambdaClass = $;
  }
  return denySelected$slambdaClass;
}
function denySelected$slambda_0($changeItems) {
  var i = new (denySelected$slambda())($changeItems);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, confirmed, $completion) {
  if (!confirmed)
    return Unit_instance;
  var tmp = voidChangeItem($this.ph7_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $this$Action, $completion) {
  var tmp = $this.qh7_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var changeItem = tmp;
  var tmp_0 = get_dialogStack();
  var tmp_1 = DangerButtonSemantic_getInstance();
  tmp_0.xgd(new (GenericConfirmationDialog())('Void Change Item?', "Voiding this item removes it from the client's consideration. This cannot be undone.", VOID, 'Void', VOID, tmp_1, VOID, VOID, VOID, VOID, voidItemAction$slambda$slambda_0(changeItem)));
  return Unit_instance;
}
var voidItemAction$slambda$slambdaClass;
function voidItemAction$slambda$slambda() {
  if (voidItemAction$slambda$slambdaClass === VOID) {
    class $ {
      constructor($changeItem) {
        this.ph7_1 = $changeItem;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    voidItemAction$slambda$slambdaClass = $;
  }
  return voidItemAction$slambda$slambdaClass;
}
function voidItemAction$slambda$slambda_0($changeItem) {
  var i = new (voidItemAction$slambda$slambda())($changeItem);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var voidItemAction$slambdaClass;
function voidItemAction$slambda() {
  if (voidItemAction$slambdaClass === VOID) {
    class $ {
      constructor($changeItem) {
        this.qh7_1 = $changeItem;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    voidItemAction$slambdaClass = $;
  }
  return voidItemAction$slambdaClass;
}
function voidItemAction$slambda_0($changeItem) {
  var i = new (voidItemAction$slambda())($changeItem);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  approveSelected as approveSelected1hdkbv3ottf9j,
  denySelected as denySelected4xcqjhjwclhe,
  voidItemAction as voidItemAction20crlyymuzk79,
  denySelectedItems as denySelectedItems3azjke2mb2k1b,
  voidChangeItem as voidChangeItem1umkby3su12s1,
};
//endregion

//# sourceMappingURL=approval.mjs.map
